import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "80",
  height: "80",
  viewBox: "0 0 80 80",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "lets-icons:img" }, [
      _createElementVNode("g", { id: "Group" }, [
        _createElementVNode("path", {
          id: "Vector",
          d: "M56.6667 26.668C60.3486 26.668 63.3333 23.6832 63.3333 20.0013C63.3333 16.3194 60.3486 13.3346 56.6667 13.3346C52.9848 13.3346 50 16.3194 50 20.0013C50 23.6832 52.9848 26.668 56.6667 26.668Z",
          fill: "black"
        }),
        _createElementVNode("path", {
          id: "Vector_2",
          d: "M36.8433 42.6374L34.6167 37.4374C33.6333 35.1474 33.1433 34.0007 32.5233 33.2541C31.6037 32.1472 30.3507 31.3676 28.9514 31.0318C27.5522 30.6959 26.0818 30.8218 24.76 31.3907C23.8733 31.7741 22.9133 32.5741 20.9967 34.1707C18.45 36.2907 17.1767 37.3541 16.1067 38.5241C12.9105 42.0218 10.855 46.4096 10.2133 51.1041C10 52.6774 10 54.3707 10 57.7607C10 59.8274 10 60.8607 10.2167 61.6907C10.5164 62.8351 11.1153 63.8791 11.9518 64.7156C12.7883 65.5521 13.8323 66.151 14.9767 66.4507C15.81 66.6674 16.82 66.6674 18.8433 66.6674H57.55C59.83 66.6674 60.97 66.6674 61.8967 66.3907C62.9604 66.0749 63.9285 65.4985 64.7131 64.7139C65.4978 63.9292 66.0742 62.9611 66.39 61.8974C66.6667 60.9707 66.6667 59.8307 66.6667 57.5507C66.6667 55.5574 66.6667 54.5607 66.53 53.6074C66.211 51.4099 65.3482 49.3269 64.02 47.5474C63.4433 46.7774 62.7367 46.0707 61.3267 44.6607L60.6267 43.9607C58.22 41.5541 57.02 40.3541 55.6567 39.8474C54.1579 39.2901 52.5088 39.2901 51.01 39.8474C49.6467 40.3541 48.4433 41.5541 46.0433 43.9607L45.6633 44.3374C43.7133 46.2874 42.7367 47.2641 41.7 47.4441C40.8948 47.5859 40.0656 47.427 39.37 46.9974C38.4767 46.4441 37.9333 45.1741 36.8433 42.6374Z",
          stroke: "black",
          "stroke-width": "6.66667"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }